// redeem.ts

import { showVoucherModal } from './redeem/showVoucherModal';

document.addEventListener('DOMContentLoaded', function () {
	showVoucherModal();
});
